import { environment } from '~env/environment';

export const API_WEEE_REQUEST_ROUTE = () =>
  `${ environment.svcAnonymousEmailsBaseUrl() }/weee`;
